import { RuleTargetsWebComponent } from './component/RuleTargetsWebComponent';
import { SelectedTagsWebComponent } from './component/SelectedTagsWebComponent';
import { EndpointTagWebComponent } from './component/EndpointTagWebComponent';

export { RuleTargetsWebComponent, SelectedTagsWebComponent, EndpointTagWebComponent };
